import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Typography,
} from '@material-ui/core';

import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from 'react-material-ui-form-validator';

import {
  NuevoInformeAfiliado,
  TraerProtocoloImagenes,
  TraerProtocoloImagenesPorId,
} from '../../../../../actions/hce/hceActions';
import { format } from 'date-fns';
import { startAlerta } from '../../../../../actions/ui/alertas';

export const ModalIngresoInforme = (props) => {
  const dispatch = useDispatch();
  const { hce, protocolos } = props;
  const [value, setValue] = useState('');
  const [descripcionProtocolog, setDescripcionProtocolo] = useState('');
  const [disabled, setDisabled] = useState(true);
  const { protocolo, dataAfiliado } = useSelector((state) => state.hce);

  const today = new Date();
  const fecha = format(today, 'dd/MM/yyyy');


  console.log(dataAfiliado)

  useEffect(() => {
    dispatch(TraerProtocoloImagenes(hce.idEfector));
    if (value !== '') {
      dispatch(TraerProtocoloImagenesPorId(value));
    }
  }, [dispatch, value]);


  useEffect(() => {
    if (protocolo?.protocolo) {
      
      let descripcionConReemplazo = protocolo.protocolo;

      descripcionConReemplazo = descripcionConReemplazo.replace(
        '[__Nombre__]',
        dataAfiliado.apellido_y_nombre,
      );

      descripcionConReemplazo = descripcionConReemplazo.replace(
        '[__nro_afi__]',
        dataAfiliado.carnet,
      );

      descripcionConReemplazo = descripcionConReemplazo.replace(
        '[__fecha__]',
        fecha,
      );

      setDescripcionProtocolo(descripcionConReemplazo)
      setDisabled(false);
    }
  }, [protocolo?.protocolo, value]);

  const onSubmitHandler = () => {
    if (protocolo?.id > 1) {
      let data = {
        idProtocolo: protocolo.id,
        informe: descripcionProtocolog,
        cuil: dataAfiliado.cuil,
        idAfiliado: hce.idAfiliado,
        idAfiliadoExterno: hce.idAfiliadoExterno,
        idAgenda: hce.idAgenda
      };
      dispatch(NuevoInformeAfiliado(data));
      props.close();
    }
 
    else {
      dispatch(startAlerta("Debe tener cargado al menos 1 protocolo para ingresar el informe.", "error"))
    }
  };

  return (
    <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ alignSelf: 'center', paddingLeft: 16 }}
            >
              {!(Array.isArray(protocolos) && protocolos.length > 0) && (
                <Typography>Profesional sin informes cargados</Typography>
              )}
                {
                  Array.isArray(protocolos) && protocolos.length > 0 && (
                    <SelectValidator
                      fullWidth
                      label="Seleccionar Protocolo"
                      name="protocolos"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      validators={['required']}
                      errorMessages={['Este campo es requerido']}
                    >
                      {protocolos.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {`${item.nombreInforme}`}
                        </MenuItem>
                      ))}
                    </SelectValidator>
                  )
                }
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ alignSelf: 'center', paddingLeft: 16 }}
            >
              {Array.isArray(protocolos) && protocolos.length > 0 && (
                <TextValidator
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={12}
                  label="Protocolo"
                  name="descripcionProtocolog"
                  value={descripcionProtocolog}
                  //onChange={handleInputChange}
                  disabled={disabled}
                />
              )}
            </Grid>
          </Grid>
          <div
            style={{
              margin: '1rem 0',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            {Array.isArray(protocolos) && protocolos.length > 0 && (
              <Button
                type="submit"
                variant="contained"
                disabled={props.disabled}
                color="primary"
              >
                Guardar
              </Button>
            )}
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
